// @ts-strict-ignore
import {Component, Input, OnInit} from "@angular/core";
import {CameraLayoutOptionsContainer} from "../../../../types/camera-layout-options";
import {BaseRecorderLayout} from "../base-recorder-layout";

@Component({
	selector: "sim-recorder-layout-quad",
	templateUrl: "./recorder-layout-quad.component.html",
	styleUrls: ["./recorder-layout-quad.component.scss"],
	standalone: false,
})
export class RecorderLayoutQuadComponent extends BaseRecorderLayout implements OnInit {
	@Input() cameraLayoutOptionsContainer: CameraLayoutOptionsContainer;

	constructor() {
		super();
	}

	ngOnInit() {}
}
